import React, { createRef } from "react";
import PropTypes from "prop-types";

import ModalPortal from "./ModalPortal";

import ModalSection from "./ModalSection";
import ModalHeading from "./ModalHeading";
import ModalActions from "./ModalActions";
import ModalAction from "./ModalAction";

export class Modal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    isVisible: PropTypes.bool,
    renderClosed: PropTypes.bool,
    closable: PropTypes.bool,
    closeText: PropTypes.string,
    trigger: PropTypes.instanceOf(
      typeof Element === "undefined" ? () => {} : Element
    ),
    beforeOpen: PropTypes.func,
    afterClose: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    portalless: PropTypes.bool,
    zIndex: PropTypes.number,
  };

  static defaultProps = {
    isOpen: true,
    isVisible: false,
    renderClosed: false,
    closable: true,
    closeText: "Schließen",
    trigger: null,
    beforeOpen: null,
    afterClose: null,
    portalless: false,
    zIndex: 1,
  };

  static displayName = "Modal";

  static Section = ModalSection;

  static Heading = ModalHeading;

  static Actions = ModalActions;

  static Action = ModalAction;

  constructor(props) {
    const { isOpen } = props;
    super(props);
    this.props = props;
    this.portalRef = createRef();
    this.state = {
      isClosing: false,
      isOpen,
    };
    this.afterClose = this.afterClose.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props;
    if (!prevProps.isOpen && isOpen) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isClosing: true,
        isOpen: false,
      });
    }
  }

  /**
   * @deprecated set isOpen prop to false instead
   */
  close() {
    this.portalRef.current.close();
  }

  afterClose() {
    this.setState({
      isClosing: false,
      isOpen: false,
    });
    const { afterClose } = this.props;
    if (typeof afterClose === "function") {
      afterClose();
    }
  }

  render() {
    const { isOpen: initialIsOpen, renderClosed, ...otherProps } = this.props;
    const { isOpen, isClosing } = this.state;
    if (!renderClosed && !isOpen && !isClosing) return "";
    return (
      <ModalPortal
        // TODO: remove ref if deprecated method close will be removed
        ref={this.portalRef}
        isOpen={initialIsOpen}
        renderClosed={renderClosed}
        {...otherProps}
        afterClose={this.afterClose}
      />
    );
  }
}

export default Modal;
